<template>
  <div class="requirement-filter w-100">
    <b-form @submit.prevent>
      <b-row class="d-flex align-items-center">
        <!-- Accept -->
        <b-col cols="3">
          <div class="text-container keyword-label-area">
            <label for="requirement-list">Type</label>
          </div>
          <b-dropdown id="status-list" class="w-100">
            <template #button-content class="status-list">
              <span>{{ selectedTypeText }}</span>
              <!-- Search Options Label-->
              <span class="icon"></span>
            </template>
            <b-dropdown-item v-for="option in typeFilterOptions" :key="option.value" :value="option.value"
              @click="setType(option.value)">
              {{ option.text }}
            </b-dropdown-item>
          </b-dropdown>
        </b-col>
        <!-- /Status -->
      </b-row>
    </b-form>
  </div>
</template>
<script>
export default {
  name: 'RequirementFilter',
  computed: {
    filter() {
      return this.$store.getters['requirement/filter'];
    },
    typeFilterOptions() {
      const allTypeOption = { text: 'All', value: '' }
      const typeOptions = this.$store.getters['requirement/typeOptions'];
      return [allTypeOption, ...typeOptions];
    },
    selectedTypeText() {
      const selectedTypeValue = this.filter.type;
      const findOption = this.typeFilterOptions.find(option => option.value === selectedTypeValue);
      return findOption ? findOption.text : '';
    },
  },
  data() {
    return {
    }
  },
  methods: {
    setType(value) {
      this.$store.commit('requirement/updateFilter', { type: value });
      this.$emit('changeFilter')
    },
    handleChangeFilter() {
      this.$emit('changeFilter')
    }
  }
}
</script>
<style scoped></style>
